import {
  Module,
  ReceivedEmailMessageCategoryType,
} from "__generated__/gql/graphql";

export const RECEIVED_EMAIL_CATEGORY_VALUES = [
  ReceivedEmailMessageCategoryType.ANALYTICS_DATA,
  ReceivedEmailMessageCategoryType.PURCHASE_ORDERS,
] as const;

export const RECEIVED_EMAIL_CATEGORY_LABELS: Record<
  ReceivedEmailMessageCategoryType,
  string
> = {
  [ReceivedEmailMessageCategoryType.ANALYTICS_DATA]: "Analytics Data",
  [ReceivedEmailMessageCategoryType.PURCHASE_ORDERS]: "Purchase Orders",
};

export const RECEIVED_EMAIL_CATEGORY_PLUS_SUFFIXES: Record<
  ReceivedEmailMessageCategoryType,
  string
> = {
  [ReceivedEmailMessageCategoryType.ANALYTICS_DATA]: "data",
  [ReceivedEmailMessageCategoryType.PURCHASE_ORDERS]: "orders",
};

export const RECEIVED_EMAIL_CATEGORY_BRAND_EMAIL_HELP_TEXT: Record<
  ReceivedEmailMessageCategoryType,
  string
> = {
  [ReceivedEmailMessageCategoryType.ANALYTICS_DATA]:
    "Used for emailing brand data and reports from distributors and retailers to be used in analytics.",
  [ReceivedEmailMessageCategoryType.PURCHASE_ORDERS]:
    "Used for emailing purchase orders received from distributors to be tracked in the Purchase Orders module.",
};

const MODULE_BY_RECEIVED_EMAIL_CATEGORY: Record<
  ReceivedEmailMessageCategoryType,
  Module
> = {
  [ReceivedEmailMessageCategoryType.ANALYTICS_DATA]: Module.ANALYTICS,
  [ReceivedEmailMessageCategoryType.PURCHASE_ORDERS]: Module.PURCHASE_ORDERS,
};

export function getShownReceivedEmailCategories(
  modules: readonly ({ module: Module | null } | null)[] | null | undefined,
): ReceivedEmailMessageCategoryType[] {
  if (!modules) return [];

  const moduleSet = new Set(
    modules
      .map((m) => m?.module)
      .filter((module): module is Module => module !== null),
  );

  return RECEIVED_EMAIL_CATEGORY_VALUES.filter((category) =>
    moduleSet.has(MODULE_BY_RECEIVED_EMAIL_CATEGORY[category]),
  );
}
